var tr = Object.defineProperty;
var nr = (t, n, i) => n in t ? tr(t, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[n] = i;
var g = (t, n, i) => nr(t, typeof n != "symbol" ? n + "" : n, i);
var bt = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, ze = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 }, Tt = new Array(4).fill(String.fromCodePoint(ze[0])).join(""), pt = "\0";
function rr(t) {
  let n = JSON.stringify(t);
  return `${Tt}${Array.from(n).map((i) => {
    let a = i.charCodeAt(0);
    if (a > 255) throw new Error(`Only ASCII edit info can be encoded. Error attempting to encode ${n} on character ${i} (${a})`);
    return Array.from(a.toString(4).padStart(4, "0")).map((s) => String.fromCodePoint(ze[s])).join("");
  }).join("")}`;
}
function ir(t) {
  return !Number.isNaN(Number(t)) || /[a-z]/i.test(t) && !/\d+(?:[-:\/]\d+){2}(?:T\d+(?:[-:\/]\d+){1,2}(\.\d+)?Z?)?/.test(t) ? !1 : !!Date.parse(t);
}
function sr(t) {
  try {
    new URL(t, t.startsWith("/") ? "https://acme.com" : void 0);
  } catch {
    return !1;
  }
  return !0;
}
function ar(t, n, i = "auto") {
  return i === !0 || i === "auto" && (ir(t) || sr(t)) ? t : `${t}${rr(n)}`;
}
var or = Object.fromEntries(Object.entries(ze).map((t) => t.reverse())), gt = Object.fromEntries(Object.entries(bt).map((t) => t.reverse())), cr = `${Object.values(bt).map((t) => `\\u{${t.toString(16)}}`).join("")}`, $e = new RegExp(`[${cr}]{4,}`, "gu");
function lr(t) {
  let n = t.match($e);
  if (n) return ur(n[0], !0)[0];
}
function ur(t, n = !1) {
  let i = Array.from(t);
  if (i.length % 2 === 0) {
    if (i.length % 4 || !t.startsWith(Tt)) return fr(i, n);
  } else throw new Error("Encoded data has invalid length");
  let a = [];
  for (let s = i.length * 0.25; s--; ) {
    let c = i.slice(s * 4, s * 4 + 4).map((u) => or[u.codePointAt(0)]).join("");
    a.unshift(String.fromCharCode(parseInt(c, 4)));
  }
  if (n) {
    a.shift();
    let s = a.indexOf(pt);
    return s === -1 && (s = a.length), [JSON.parse(a.slice(0, s).join(""))];
  }
  return a.join("").split(pt).filter(Boolean).map((s) => JSON.parse(s));
}
function fr(t, n) {
  var i;
  let a = [];
  for (let d = t.length * 0.5; d--; ) {
    let h = `${gt[t[d * 2].codePointAt(0)]}${gt[t[d * 2 + 1].codePointAt(0)]}`;
    a.unshift(String.fromCharCode(parseInt(h, 16)));
  }
  let s = [], c = [a.join("")], u = 10;
  for (; c.length; ) {
    let d = c.shift();
    try {
      if (s.push(JSON.parse(d)), n) return s;
    } catch (h) {
      if (!u--) throw h;
      let f = +((i = h.message.match(/\sposition\s(\d+)$/)) == null ? void 0 : i[1]);
      if (!f) throw h;
      c.unshift(d.substring(0, f), d.substring(f));
    }
  }
  return s;
}
function dr(t) {
  var n;
  return { cleaned: t.replace($e, ""), encoded: ((n = t.match($e)) == null ? void 0 : n[0]) || "" };
}
function Oe(t, n) {
  return ar(t, n);
}
function pr(t) {
  return lr(t);
}
function Wr(t) {
  return dr(t);
}
var gr = Object.prototype.hasOwnProperty, hr = Object.prototype.toString, Er = function(t, n, i) {
  if (hr.call(n) !== "[object Function]")
    throw new TypeError("iterator must be a function");
  var a = t.length;
  if (a === +a)
    for (var s = 0; s < a; s++)
      n.call(i, t[s], s, t);
  else
    for (var c in t)
      gr.call(t, c) && n.call(i, t[c], c, t);
}, yr = Er, H = m;
function m(t, n, i) {
  if (arguments.length === 3)
    return m.set(t, n, i);
  if (arguments.length === 2)
    return m.get(t, n);
  var a = m.bind(m, t);
  for (var s in m)
    m.hasOwnProperty(s) && (a[s] = m[s].bind(a, t));
  return a;
}
m.get = function(t, n) {
  for (var i = Array.isArray(n) ? n : m.parse(n), a = 0; a < i.length; ++a) {
    var s = i[a];
    if (!(typeof t == "object" && s in t))
      throw new Error("Invalid reference token: " + s);
    t = t[s];
  }
  return t;
};
m.set = function(t, n, i) {
  var a = Array.isArray(n) ? n : m.parse(n), s = a[0];
  if (a.length === 0)
    throw Error("Can not set the root object");
  for (var c = 0; c < a.length - 1; ++c) {
    var u = a[c];
    typeof u != "string" && typeof u != "number" && (u = String(u)), !(u === "__proto__" || u === "constructor" || u === "prototype") && (u === "-" && Array.isArray(t) && (u = t.length), s = a[c + 1], u in t || (s.match(/^(\d+|-)$/) ? t[u] = [] : t[u] = {}), t = t[u]);
  }
  return s === "-" && Array.isArray(t) && (s = t.length), t[s] = i, this;
};
m.remove = function(t, n) {
  var i = Array.isArray(n) ? n : m.parse(n), a = i[i.length - 1];
  if (a === void 0)
    throw new Error('Invalid JSON pointer for remove: "' + n + '"');
  var s = m.get(t, i.slice(0, -1));
  if (Array.isArray(s)) {
    var c = +a;
    if (a === "" && isNaN(c))
      throw new Error('Invalid array index: "' + a + '"');
    Array.prototype.splice.call(s, c, 1);
  } else
    delete s[a];
};
m.dict = function(t, n) {
  var i = {};
  return m.walk(t, function(a, s) {
    i[s] = a;
  }, n), i;
};
m.walk = function(t, n, i) {
  var a = [];
  i = i || function(s) {
    var c = Object.prototype.toString.call(s);
    return c === "[object Object]" || c === "[object Array]";
  }, function s(c) {
    yr(c, function(u, d) {
      a.push(String(d)), i(u) ? s(u) : n(u, m.compile(a)), a.pop();
    });
  }(t);
};
m.has = function(t, n) {
  try {
    m.get(t, n);
  } catch {
    return !1;
  }
  return !0;
};
m.escape = function(t) {
  return t.toString().replace(/~/g, "~0").replace(/\//g, "~1");
};
m.unescape = function(t) {
  return t.replace(/~1/g, "/").replace(/~0/g, "~");
};
m.parse = function(t) {
  if (t === "")
    return [];
  if (t.charAt(0) !== "/")
    throw new Error("Invalid JSON pointer: " + t);
  return t.substring(1).split(/\//).map(m.unescape);
};
m.compile = function(t) {
  return t.length === 0 ? "" : "/" + t.map(m.escape).join("/");
};
const mr = ({
  pointer: t,
  mappings: n,
  data: i,
  hiddenStrings: a
}) => {
  const s = n[t];
  delete n[t];
  const c = _t(i, t);
  for (const u of c) {
    n[u] = s;
    const d = H.get(i, u), h = Oe(d, a);
    H.set(i, u, h);
  }
}, _t = (t, n = "") => {
  const i = [], a = H.get(t, n);
  if (a.content)
    for (let s = 0; s < a.content.length; s++)
      a.content[s].nodeType === "text" ? i.push(`${n}/content/${s}/value`) : i.push(..._t(t, `${n}/content/${s}`));
  return i;
}, Ge = ({
  entityId: t,
  entityType: n,
  space: i,
  environment: a,
  field: s,
  locale: c,
  editorInterface: u,
  fieldType: d,
  targetOrigin: h,
  platform: f
}) => {
  const E = {
    origin: "contentful.com",
    href: `${`${h || "https://app.contentful.com"}/spaces/${i}/environments/${a}`}/${n === "Entry" ? "entries" : "assets"}/${t}/?focusedField=${s}&focusedLocale=${c}&source=vercel-content-link`,
    contentful: {
      space: i,
      environment: a,
      field: s,
      locale: c,
      entity: t,
      entityType: n,
      editorInterface: u,
      fieldType: d
    }
  };
  return f === "vercel" && delete E.contentful, f === "contentful" && delete E.href, E;
}, vt = (t) => ["builtin", "sidebar-builtin", "editor-builtin"].includes(t), St = (t) => br.includes(t);
function At(t) {
  if (typeof structuredClone == "function")
    return structuredClone(t);
  try {
    return JSON.parse(JSON.stringify(t));
  } catch (n) {
    return console.warn("Failed to clone data:", t, n), t;
  }
}
const br = [
  "singleLine",
  "tagEditor",
  "listInput",
  "checkbox",
  "richTextEditor",
  "multipleLine"
];
function Be(t, n, i, a, s, c, u) {
  const d = u ? n[u] : n;
  switch (t) {
    case "Symbol": {
      const h = Oe(d, i);
      H.set(a, s, h);
      break;
    }
    case "Text": {
      const h = Oe(d, i);
      H.set(a, s, h);
      break;
    }
    case "RichText": {
      mr({
        pointer: "",
        mappings: c,
        data: d,
        hiddenStrings: i
      });
      break;
    }
    case "Array": {
      const h = d.map((f) => typeof f == "string" ? Oe(f, i) : f);
      H.set(a, s, h);
      break;
    }
  }
}
const Qr = (t, n, i) => {
  if (!t || !t.extensions || !t.extensions.contentSourceMaps)
    return console.error(
      "GraphQL response does not contain Content Source Maps information.",
      t
    ), t;
  const a = At(
    t
  ), {
    spaces: s,
    environments: c,
    editorInterfaces: u,
    fields: d,
    locales: h,
    entries: f,
    assets: E,
    mappings: b,
    fieldTypes: I
  } = a.extensions.contentSourceMaps, R = a;
  for (const O in b) {
    const { source: v } = b[O], N = "entry" in v ? f[v.entry] : E[v.asset], G = "entry" in v ? "Entry" : "Asset";
    if (!N)
      return a;
    const x = s[N.space], B = c[N.environment], ae = N.id, de = d[v.field], re = h[v.locale], ie = u[v.editorInterface], pe = I[v.fieldType];
    if (!(vt(ie.widgetNamespace) && !St(ie.widgetId)))
      if (H.has(R, O)) {
        const ge = H.get(R, O);
        if (ge !== null) {
          const oe = Ge({
            entityId: ae,
            entityType: G,
            space: x,
            environment: B,
            field: de,
            locale: re,
            editorInterface: ie,
            fieldType: pe,
            targetOrigin: n,
            platform: i
          });
          Be(pe, ge, oe, R, O, b);
        }
      } else
        console.error(`Pointer ${O} not found in GraphQL data or href could not be generated.`);
  }
  return a;
}, Ae = (t, n, i, a, s) => {
  if (!t.fields)
    return;
  const { contentSourceMaps: c } = t.sys;
  if (!c) {
    console.error("Content source maps data is missing");
    return;
  }
  const { mappings: u } = c;
  for (const d in u) {
    const { source: h } = u[d], f = t.sys.space.sys.id, E = t.sys.environment.sys.id, b = t.sys.id, I = t.sys.type, R = n[h.fieldType], O = i[h.editorInterface];
    if (vt(O.widgetNamespace) && !St(O.widgetId))
      continue;
    const v = d.startsWith("/") ? d : `/${d}`;
    if (H.has(t, v)) {
      const N = H.get(t, v);
      if (N === null)
        return;
      const G = v.split("/").pop();
      if (!G) {
        console.error("Field name could not be extracted from the pointer", v);
        return;
      }
      const x = t.sys.locale;
      if (x) {
        const B = Ge({
          entityId: b,
          entityType: I,
          space: f,
          environment: E,
          field: G,
          locale: x,
          editorInterface: O,
          fieldType: R,
          targetOrigin: a,
          platform: s
        });
        Be(R, N, B, t, v, u);
      } else
        Object.keys(N).forEach((B) => {
          const ae = Ge({
            entityId: b,
            entityType: I,
            space: f,
            environment: E,
            field: G,
            locale: B,
            editorInterface: O,
            fieldType: R,
            targetOrigin: a,
            platform: s
          });
          Be(
            R,
            N,
            ae,
            t,
            `${v}/${B}`,
            u,
            B
          );
        });
    } else
      console.error("Pointer not found in the target", d, t);
  }
}, Xr = (t, n, i) => {
  var a;
  const s = At(
    t
  );
  if (s.sys && "items" in s) {
    const c = s;
    if (!((a = c.sys) != null && a.contentSourceMapsLookup))
      return console.error("Content source maps lookup data is missing"), c;
    const {
      contentSourceMapsLookup: { fieldTypes: u, editorInterfaces: d }
    } = c.sys, { items: h, includes: f } = c;
    h.forEach(
      (E) => Ae(E, u, d, n, i)
    ), f && f.Entry && f.Entry.forEach(
      (E) => Ae(E, u, d, n, i)
    ), f && f.Asset && f.Asset.forEach(
      (E) => Ae(E, u, d, n, i)
    );
  } else {
    const c = s;
    if (!c.sys.contentSourceMapsLookup)
      return console.error("Content source maps lookup data is missing"), c;
    Ae(
      c,
      c.sys.contentSourceMapsLookup.fieldTypes,
      c.sys.contentSourceMapsLookup.editorInterfaces,
      n,
      i
    );
  }
  return s;
}, It = "4.5.4";
let Ot = !1;
function ht(t) {
  Ot = t;
}
const xe = (t) => (...n) => {
  Ot && console[t](...n);
}, W = {
  error: xe("error"),
  warn: xe("warn"),
  log: xe("log")
};
function Tr(t, n = 500) {
  let i = window.location.href;
  const s = setInterval(() => {
    const c = window.location.href;
    c !== i && (i = c, t(c));
  }, n);
  return () => clearInterval(s);
}
const _r = "live-preview-editor", vr = "live-preview-sdk";
function F(t, n, i) {
  const a = {
    ...n,
    method: t,
    source: vr,
    location: window.location.href,
    version: It
  };
  W.log("Send message", a), i.forEach((s) => {
    var c;
    (c = window.top) == null || c.postMessage(a, s);
  });
}
function Sr(t, n = 100) {
  let i;
  return (...a) => {
    clearTimeout(i), i = setTimeout(() => {
      t.apply(this, a);
    }, n);
  };
}
function Ar() {
  var t;
  try {
    return ((t = window.top) == null ? void 0 : t.location.href) !== window.location.href;
  } catch {
    return !0;
  }
}
function Ir() {
  return `${performance.now()}-${Math.random().toString(36).slice(2)}`;
}
function Or(t) {
  return typeof t.data != "object" || !t.data ? !1 : "source" in t.data && t.data.source === _r;
}
var Ie = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Cr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Ce = { exports: {} };
Ce.exports;
(function(t, n) {
  var i = 200, a = "__lodash_hash_undefined__", s = 1, c = 2, u = 9007199254740991, d = "[object Arguments]", h = "[object Array]", f = "[object AsyncFunction]", E = "[object Boolean]", b = "[object Date]", I = "[object Error]", R = "[object Function]", O = "[object GeneratorFunction]", v = "[object Map]", N = "[object Number]", G = "[object Null]", x = "[object Object]", B = "[object Promise]", ae = "[object Proxy]", de = "[object RegExp]", re = "[object Set]", ie = "[object String]", pe = "[object Symbol]", ge = "[object Undefined]", oe = "[object WeakMap]", Pe = "[object ArrayBuffer]", he = "[object DataView]", Lt = "[object Float32Array]", Rt = "[object Float64Array]", Ut = "[object Int8Array]", Mt = "[object Int16Array]", jt = "[object Int32Array]", xt = "[object Uint8Array]", $t = "[object Uint8ClampedArray]", Gt = "[object Uint16Array]", Bt = "[object Uint32Array]", zt = /[\\^$.*+?()[\]{}|]/g, Ft = /^\[object .+?Constructor\]$/, Pt = /^(?:0|[1-9]\d*)$/, T = {};
  T[Lt] = T[Rt] = T[Ut] = T[Mt] = T[jt] = T[xt] = T[$t] = T[Gt] = T[Bt] = !0, T[d] = T[h] = T[Pe] = T[E] = T[he] = T[b] = T[I] = T[R] = T[v] = T[N] = T[x] = T[de] = T[re] = T[ie] = T[oe] = !1;
  var He = typeof Ie == "object" && Ie && Ie.Object === Object && Ie, Ht = typeof self == "object" && self && self.Object === Object && self, V = He || Ht || Function("return this")(), Ve = n && !n.nodeType && n, Ye = Ve && !0 && t && !t.nodeType && t, Ke = Ye && Ye.exports === Ve, we = Ke && He.process, Je = function() {
    try {
      return we && we.binding && we.binding("util");
    } catch {
    }
  }(), qe = Je && Je.isTypedArray;
  function Vt(e, r) {
    for (var o = -1, l = e == null ? 0 : e.length, _ = 0, p = []; ++o < l; ) {
      var A = e[o];
      r(A, o, e) && (p[_++] = A);
    }
    return p;
  }
  function Yt(e, r) {
    for (var o = -1, l = r.length, _ = e.length; ++o < l; )
      e[_ + o] = r[o];
    return e;
  }
  function Kt(e, r) {
    for (var o = -1, l = e == null ? 0 : e.length; ++o < l; )
      if (r(e[o], o, e))
        return !0;
    return !1;
  }
  function Jt(e, r) {
    for (var o = -1, l = Array(e); ++o < e; )
      l[o] = r(o);
    return l;
  }
  function qt(e) {
    return function(r) {
      return e(r);
    };
  }
  function Zt(e, r) {
    return e.has(r);
  }
  function Wt(e, r) {
    return e == null ? void 0 : e[r];
  }
  function Qt(e) {
    var r = -1, o = Array(e.size);
    return e.forEach(function(l, _) {
      o[++r] = [_, l];
    }), o;
  }
  function Xt(e, r) {
    return function(o) {
      return e(r(o));
    };
  }
  function kt(e) {
    var r = -1, o = Array(e.size);
    return e.forEach(function(l) {
      o[++r] = l;
    }), o;
  }
  var en = Array.prototype, tn = Function.prototype, Ee = Object.prototype, De = V["__core-js_shared__"], Ze = tn.toString, z = Ee.hasOwnProperty, We = function() {
    var e = /[^.]+$/.exec(De && De.keys && De.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }(), Qe = Ee.toString, nn = RegExp(
    "^" + Ze.call(z).replace(zt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Xe = Ke ? V.Buffer : void 0, ye = V.Symbol, ke = V.Uint8Array, et = Ee.propertyIsEnumerable, rn = en.splice, Q = ye ? ye.toStringTag : void 0, tt = Object.getOwnPropertySymbols, sn = Xe ? Xe.isBuffer : void 0, an = Xt(Object.keys, Object), Ne = se(V, "DataView"), ce = se(V, "Map"), Le = se(V, "Promise"), Re = se(V, "Set"), Ue = se(V, "WeakMap"), le = se(Object, "create"), on = ee(Ne), cn = ee(ce), ln = ee(Le), un = ee(Re), fn = ee(Ue), nt = ye ? ye.prototype : void 0, Me = nt ? nt.valueOf : void 0;
  function X(e) {
    var r = -1, o = e == null ? 0 : e.length;
    for (this.clear(); ++r < o; ) {
      var l = e[r];
      this.set(l[0], l[1]);
    }
  }
  function dn() {
    this.__data__ = le ? le(null) : {}, this.size = 0;
  }
  function pn(e) {
    var r = this.has(e) && delete this.__data__[e];
    return this.size -= r ? 1 : 0, r;
  }
  function gn(e) {
    var r = this.__data__;
    if (le) {
      var o = r[e];
      return o === a ? void 0 : o;
    }
    return z.call(r, e) ? r[e] : void 0;
  }
  function hn(e) {
    var r = this.__data__;
    return le ? r[e] !== void 0 : z.call(r, e);
  }
  function En(e, r) {
    var o = this.__data__;
    return this.size += this.has(e) ? 0 : 1, o[e] = le && r === void 0 ? a : r, this;
  }
  X.prototype.clear = dn, X.prototype.delete = pn, X.prototype.get = gn, X.prototype.has = hn, X.prototype.set = En;
  function Y(e) {
    var r = -1, o = e == null ? 0 : e.length;
    for (this.clear(); ++r < o; ) {
      var l = e[r];
      this.set(l[0], l[1]);
    }
  }
  function yn() {
    this.__data__ = [], this.size = 0;
  }
  function mn(e) {
    var r = this.__data__, o = be(r, e);
    if (o < 0)
      return !1;
    var l = r.length - 1;
    return o == l ? r.pop() : rn.call(r, o, 1), --this.size, !0;
  }
  function bn(e) {
    var r = this.__data__, o = be(r, e);
    return o < 0 ? void 0 : r[o][1];
  }
  function Tn(e) {
    return be(this.__data__, e) > -1;
  }
  function _n(e, r) {
    var o = this.__data__, l = be(o, e);
    return l < 0 ? (++this.size, o.push([e, r])) : o[l][1] = r, this;
  }
  Y.prototype.clear = yn, Y.prototype.delete = mn, Y.prototype.get = bn, Y.prototype.has = Tn, Y.prototype.set = _n;
  function k(e) {
    var r = -1, o = e == null ? 0 : e.length;
    for (this.clear(); ++r < o; ) {
      var l = e[r];
      this.set(l[0], l[1]);
    }
  }
  function vn() {
    this.size = 0, this.__data__ = {
      hash: new X(),
      map: new (ce || Y)(),
      string: new X()
    };
  }
  function Sn(e) {
    var r = Te(this, e).delete(e);
    return this.size -= r ? 1 : 0, r;
  }
  function An(e) {
    return Te(this, e).get(e);
  }
  function In(e) {
    return Te(this, e).has(e);
  }
  function On(e, r) {
    var o = Te(this, e), l = o.size;
    return o.set(e, r), this.size += o.size == l ? 0 : 1, this;
  }
  k.prototype.clear = vn, k.prototype.delete = Sn, k.prototype.get = An, k.prototype.has = In, k.prototype.set = On;
  function me(e) {
    var r = -1, o = e == null ? 0 : e.length;
    for (this.__data__ = new k(); ++r < o; )
      this.add(e[r]);
  }
  function Cn(e) {
    return this.__data__.set(e, a), this;
  }
  function wn(e) {
    return this.__data__.has(e);
  }
  me.prototype.add = me.prototype.push = Cn, me.prototype.has = wn;
  function J(e) {
    var r = this.__data__ = new Y(e);
    this.size = r.size;
  }
  function Dn() {
    this.__data__ = new Y(), this.size = 0;
  }
  function Nn(e) {
    var r = this.__data__, o = r.delete(e);
    return this.size = r.size, o;
  }
  function Ln(e) {
    return this.__data__.get(e);
  }
  function Rn(e) {
    return this.__data__.has(e);
  }
  function Un(e, r) {
    var o = this.__data__;
    if (o instanceof Y) {
      var l = o.__data__;
      if (!ce || l.length < i - 1)
        return l.push([e, r]), this.size = ++o.size, this;
      o = this.__data__ = new k(l);
    }
    return o.set(e, r), this.size = o.size, this;
  }
  J.prototype.clear = Dn, J.prototype.delete = Nn, J.prototype.get = Ln, J.prototype.has = Rn, J.prototype.set = Un;
  function Mn(e, r) {
    var o = _e(e), l = !o && Zn(e), _ = !o && !l && je(e), p = !o && !l && !_ && ft(e), A = o || l || _ || p, C = A ? Jt(e.length, String) : [], w = C.length;
    for (var S in e)
      z.call(e, S) && !(A && // Safari 9 has enumerable `arguments.length` in strict mode.
      (S == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      _ && (S == "offset" || S == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      p && (S == "buffer" || S == "byteLength" || S == "byteOffset") || // Skip index properties.
      Vn(S, w))) && C.push(S);
    return C;
  }
  function be(e, r) {
    for (var o = e.length; o--; )
      if (ot(e[o][0], r))
        return o;
    return -1;
  }
  function jn(e, r, o) {
    var l = r(e);
    return _e(e) ? l : Yt(l, o(e));
  }
  function ue(e) {
    return e == null ? e === void 0 ? ge : G : Q && Q in Object(e) ? Pn(e) : qn(e);
  }
  function rt(e) {
    return fe(e) && ue(e) == d;
  }
  function it(e, r, o, l, _) {
    return e === r ? !0 : e == null || r == null || !fe(e) && !fe(r) ? e !== e && r !== r : xn(e, r, o, l, it, _);
  }
  function xn(e, r, o, l, _, p) {
    var A = _e(e), C = _e(r), w = A ? h : q(e), S = C ? h : q(r);
    w = w == d ? x : w, S = S == d ? x : S;
    var U = w == x, $ = S == x, D = w == S;
    if (D && je(e)) {
      if (!je(r))
        return !1;
      A = !0, U = !1;
    }
    if (D && !U)
      return p || (p = new J()), A || ft(e) ? st(e, r, o, l, _, p) : zn(e, r, w, o, l, _, p);
    if (!(o & s)) {
      var M = U && z.call(e, "__wrapped__"), j = $ && z.call(r, "__wrapped__");
      if (M || j) {
        var Z = M ? e.value() : e, K = j ? r.value() : r;
        return p || (p = new J()), _(Z, K, o, l, p);
      }
    }
    return D ? (p || (p = new J()), Fn(e, r, o, l, _, p)) : !1;
  }
  function $n(e) {
    if (!ut(e) || Kn(e))
      return !1;
    var r = ct(e) ? nn : Ft;
    return r.test(ee(e));
  }
  function Gn(e) {
    return fe(e) && lt(e.length) && !!T[ue(e)];
  }
  function Bn(e) {
    if (!Jn(e))
      return an(e);
    var r = [];
    for (var o in Object(e))
      z.call(e, o) && o != "constructor" && r.push(o);
    return r;
  }
  function st(e, r, o, l, _, p) {
    var A = o & s, C = e.length, w = r.length;
    if (C != w && !(A && w > C))
      return !1;
    var S = p.get(e);
    if (S && p.get(r))
      return S == r;
    var U = -1, $ = !0, D = o & c ? new me() : void 0;
    for (p.set(e, r), p.set(r, e); ++U < C; ) {
      var M = e[U], j = r[U];
      if (l)
        var Z = A ? l(j, M, U, r, e, p) : l(M, j, U, e, r, p);
      if (Z !== void 0) {
        if (Z)
          continue;
        $ = !1;
        break;
      }
      if (D) {
        if (!Kt(r, function(K, te) {
          if (!Zt(D, te) && (M === K || _(M, K, o, l, p)))
            return D.push(te);
        })) {
          $ = !1;
          break;
        }
      } else if (!(M === j || _(M, j, o, l, p))) {
        $ = !1;
        break;
      }
    }
    return p.delete(e), p.delete(r), $;
  }
  function zn(e, r, o, l, _, p, A) {
    switch (o) {
      case he:
        if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
          return !1;
        e = e.buffer, r = r.buffer;
      case Pe:
        return !(e.byteLength != r.byteLength || !p(new ke(e), new ke(r)));
      case E:
      case b:
      case N:
        return ot(+e, +r);
      case I:
        return e.name == r.name && e.message == r.message;
      case de:
      case ie:
        return e == r + "";
      case v:
        var C = Qt;
      case re:
        var w = l & s;
        if (C || (C = kt), e.size != r.size && !w)
          return !1;
        var S = A.get(e);
        if (S)
          return S == r;
        l |= c, A.set(e, r);
        var U = st(C(e), C(r), l, _, p, A);
        return A.delete(e), U;
      case pe:
        if (Me)
          return Me.call(e) == Me.call(r);
    }
    return !1;
  }
  function Fn(e, r, o, l, _, p) {
    var A = o & s, C = at(e), w = C.length, S = at(r), U = S.length;
    if (w != U && !A)
      return !1;
    for (var $ = w; $--; ) {
      var D = C[$];
      if (!(A ? D in r : z.call(r, D)))
        return !1;
    }
    var M = p.get(e);
    if (M && p.get(r))
      return M == r;
    var j = !0;
    p.set(e, r), p.set(r, e);
    for (var Z = A; ++$ < w; ) {
      D = C[$];
      var K = e[D], te = r[D];
      if (l)
        var dt = A ? l(te, K, D, r, e, p) : l(K, te, D, e, r, p);
      if (!(dt === void 0 ? K === te || _(K, te, o, l, p) : dt)) {
        j = !1;
        break;
      }
      Z || (Z = D == "constructor");
    }
    if (j && !Z) {
      var ve = e.constructor, Se = r.constructor;
      ve != Se && "constructor" in e && "constructor" in r && !(typeof ve == "function" && ve instanceof ve && typeof Se == "function" && Se instanceof Se) && (j = !1);
    }
    return p.delete(e), p.delete(r), j;
  }
  function at(e) {
    return jn(e, Xn, Hn);
  }
  function Te(e, r) {
    var o = e.__data__;
    return Yn(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  function se(e, r) {
    var o = Wt(e, r);
    return $n(o) ? o : void 0;
  }
  function Pn(e) {
    var r = z.call(e, Q), o = e[Q];
    try {
      e[Q] = void 0;
      var l = !0;
    } catch {
    }
    var _ = Qe.call(e);
    return l && (r ? e[Q] = o : delete e[Q]), _;
  }
  var Hn = tt ? function(e) {
    return e == null ? [] : (e = Object(e), Vt(tt(e), function(r) {
      return et.call(e, r);
    }));
  } : kn, q = ue;
  (Ne && q(new Ne(new ArrayBuffer(1))) != he || ce && q(new ce()) != v || Le && q(Le.resolve()) != B || Re && q(new Re()) != re || Ue && q(new Ue()) != oe) && (q = function(e) {
    var r = ue(e), o = r == x ? e.constructor : void 0, l = o ? ee(o) : "";
    if (l)
      switch (l) {
        case on:
          return he;
        case cn:
          return v;
        case ln:
          return B;
        case un:
          return re;
        case fn:
          return oe;
      }
    return r;
  });
  function Vn(e, r) {
    return r = r ?? u, !!r && (typeof e == "number" || Pt.test(e)) && e > -1 && e % 1 == 0 && e < r;
  }
  function Yn(e) {
    var r = typeof e;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
  }
  function Kn(e) {
    return !!We && We in e;
  }
  function Jn(e) {
    var r = e && e.constructor, o = typeof r == "function" && r.prototype || Ee;
    return e === o;
  }
  function qn(e) {
    return Qe.call(e);
  }
  function ee(e) {
    if (e != null) {
      try {
        return Ze.call(e);
      } catch {
      }
      try {
        return e + "";
      } catch {
      }
    }
    return "";
  }
  function ot(e, r) {
    return e === r || e !== e && r !== r;
  }
  var Zn = rt(/* @__PURE__ */ function() {
    return arguments;
  }()) ? rt : function(e) {
    return fe(e) && z.call(e, "callee") && !et.call(e, "callee");
  }, _e = Array.isArray;
  function Wn(e) {
    return e != null && lt(e.length) && !ct(e);
  }
  var je = sn || er;
  function Qn(e, r) {
    return it(e, r);
  }
  function ct(e) {
    if (!ut(e))
      return !1;
    var r = ue(e);
    return r == R || r == O || r == f || r == ae;
  }
  function lt(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= u;
  }
  function ut(e) {
    var r = typeof e;
    return e != null && (r == "object" || r == "function");
  }
  function fe(e) {
    return e != null && typeof e == "object";
  }
  var ft = qe ? qt(qe) : Gn;
  function Xn(e) {
    return Wn(e) ? Mn(e) : Bn(e);
  }
  function kn() {
    return [];
  }
  function er() {
    return !1;
  }
  t.exports = Qn;
})(Ce, Ce.exports);
var wr = Ce.exports;
const Dr = /* @__PURE__ */ Cr(wr);
var y = /* @__PURE__ */ ((t) => (t.FIELD_ID = "data-contentful-field-id", t.ENTRY_ID = "data-contentful-entry-id", t.ASSET_ID = "data-contentful-asset-id", t.LOCALE = "data-contentful-locale", t.SPACE = "data-contentful-space", t.ENVIRONMENT = "data-contentful-environment", t))(y || {}), ne = /* @__PURE__ */ ((t) => (t.MOUSE_MOVE = "MOUSE_MOVE", t.SCROLL_START = "SCROLL_START", t.SCROLL_END = "SCROLL_END", t.RESIZE_START = "RESIZE_START", t.RESIZE_END = "RESIZE_END", t.TAGGED_ELEMENTS = "TAGGED_ELEMENTS", t.INSPECTOR_MODE_CHANGED = "INSPECTOR_MODE_CHANGED", t))(ne || {}), Ct = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, wt = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 };
new Array(4).fill(String.fromCodePoint(wt[0])).join("");
Object.fromEntries(Object.entries(wt).map((t) => t.reverse()));
Object.fromEntries(Object.entries(Ct).map((t) => t.reverse()));
var Nr = `${Object.values(Ct).map((t) => `\\u{${t.toString(16)}}`).join("")}`, Lr = new RegExp(`[${Nr}]{4,}`, "gu");
const Rr = (t) => {
  if (!t || t.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const n = t;
  return !(!n.hasAttribute(y.FIELD_ID) || !n.hasAttribute(y.ENTRY_ID) && !n.hasAttribute(y.ASSET_ID));
};
function Ur(t, n) {
  if (!Rr(t))
    return null;
  const i = {
    fieldId: t.getAttribute(y.FIELD_ID),
    locale: t.getAttribute(y.LOCALE) ?? n.locale,
    environment: t.getAttribute(y.ENVIRONMENT) ?? n.environment,
    space: t.getAttribute(y.SPACE) ?? n.space,
    manuallyTagged: !0
  }, a = t.getAttribute(y.ENTRY_ID);
  if (a)
    return { ...i, entryId: a };
  const s = t.getAttribute(y.ASSET_ID);
  return s ? { ...i, assetId: s } : null;
}
function Dt(t, n) {
  return t.href === n.href;
}
function Mr(t, n) {
  return !(!Dt(t.sourceMap, n.sourceMap) || t.element !== n.element);
}
function jr(t) {
  let n = [];
  return typeof t.matches == "function" && t.matches("*") && (n = [t]), [
    ...n,
    ...Array.from(t.querySelectorAll("*:not(script,style,meta,title)"))
  ].map((i) => ({ node: i, text: xr(i) })).filter(({ text: i }) => !!(i && i.match(Lr)));
}
function xr(t) {
  return t.matches("input[type=submit], input[type=button], input[type=reset]") ? t.value : t.matches("img, video") ? t.alt : Array.from(t.childNodes).filter((n) => n.nodeType === Node.TEXT_NODE && !!n.textContent).map((n) => n.textContent).join("");
}
function $r(t, n) {
  for (const i of n)
    if (i.element === t || i.element.contains(t))
      return !0;
  return !1;
}
function Fe({
  root: t = window.document,
  options: n,
  ignoreManual: i
}) {
  const s = [...i ? [] : t.querySelectorAll(
    `[${y.ASSET_ID}][${y.FIELD_ID}], [${y.ENTRY_ID}][${y.FIELD_ID}]`
  )].map((f) => ({
    element: f,
    attributes: Ur(f, n)
  })).filter(({ attributes: f }) => f !== null), c = [], u = jr("body" in t ? t.body : t);
  for (const { node: f, text: E } of u) {
    const b = pr(E);
    if (!(!b || !b.origin.includes("contentful.com")) && !($r(f, s) || c.some(
      (I) => I.element.contains(f) && Dt(I.sourceMap, b)
    ))) {
      if (f.matches("img")) {
        const I = f.closest("figure") || f.closest("picture") || f;
        c.push({ element: I, sourceMap: b });
        continue;
      }
      c.push({ element: f, sourceMap: b });
    }
  }
  const d = c.filter(
    (f, E) => c.findIndex((b) => Mr(f, b)) === E
  );
  for (const { element: f, sourceMap: E } of d) {
    if (!E.contentful) {
      W.warn(
        "Element has missing information in their ContentSourceMap, please check if you have restricted the platform for the encoding. (Missing parameter: `contentful`)",
        {
          element: f,
          sourceMap: E
        }
      );
      continue;
    }
    const b = {
      fieldId: E.contentful.field,
      locale: E.contentful.locale,
      space: E.contentful.space,
      environment: E.contentful.environment
    };
    E.contentful.entityType === "Asset" ? b.assetId = E.contentful.entity : E.contentful.entityType === "Entry" && (b.entryId = E.contentful.entity), s.push({
      element: f,
      attributes: b
    });
  }
  const h = s.filter(
    ({ attributes: f }) => (f == null ? void 0 : f.manuallyTagged) === !1 || !(f != null && f.manuallyTagged)
  ).length;
  return {
    taggedElements: s,
    manuallyTaggedCount: s.length - h,
    automaticallyTaggedCount: h,
    autoTaggedElements: d
  };
}
function Nt({
  options: t
}) {
  return [
    ...new Set(
      Fe({ options: t }).taggedElements.map((n) => n.attributes && "entryId" in n.attributes ? n.attributes.entryId : null).filter(Boolean)
    )
  ];
}
class Gr {
  constructor(n) {
    g(this, "delay", 300);
    g(this, "isScrolling", !1);
    g(this, "scrollTimeout");
    g(this, "isResizing", !1);
    g(this, "resizeTimeout");
    g(this, "hoveredElement");
    g(this, "taggedElements", []);
    g(this, "manuallyTaggedCount", 0);
    g(this, "automaticallyTaggedCount", 0);
    g(this, "intersectionObserver");
    g(this, "observersCB", []);
    g(this, "cleanupCB", []);
    /**
     * Attaches the event listeners and send the tagged elements once
     */
    g(this, "init", () => {
      this.cleanupCB = [
        this.addScrollListener(),
        this.addMutationListener(document.body),
        this.addResizeListener(),
        this.addHoverListener()
      ], this.updateElements();
    });
    /**
     * Cancels all listeners and observers
     */
    g(this, "cleanup", () => {
      this.observersCB.forEach((n) => n()), this.cleanupCB.forEach((n) => n());
    });
    // Handles incoming messages from Contentful
    g(this, "receiveMessage", (n) => {
      if (n.method === ne.INSPECTOR_MODE_CHANGED) {
        const { isInspectorActive: i } = n;
        i ? this.init() : this.cleanup();
      }
    });
    /** Listen for changes on the element via intersection and mutation observer */
    g(this, "observe", (n) => {
      this.intersectionObserver.observe(n);
      const i = this.addMutationListener(n);
      this.observersCB.push(i, () => this.intersectionObserver.unobserve(n));
    });
    /** Sends scroll start and end event to the editor, on end it also sends the tagged elements again */
    g(this, "addScrollListener", () => {
      const { targetOrigin: n } = this.options, i = () => {
        this.isScrolling || (this.isScrolling = !0, F(ne.SCROLL_START, {}, n)), this.scrollTimeout && clearTimeout(this.scrollTimeout), this.scrollTimeout = setTimeout(() => {
          this.isScrolling = !1, F(ne.SCROLL_END, {}, n), this.updateElements();
        }, this.delay);
      }, a = { capture: !0, passive: !0 };
      return window.addEventListener("scroll", i, a), () => window.removeEventListener("scroll", i, a);
    });
    /** Detects DOM changes and sends the tagged elements to the editor */
    g(this, "addMutationListener", (n) => {
      const i = new MutationObserver(() => {
        this.updateElements();
      });
      return i.observe(n, {
        // Content source maps
        characterData: !0,
        // Manual tagging
        attributes: !0,
        attributeFilter: [
          y.ENTRY_ID,
          y.FIELD_ID,
          y.LOCALE,
          y.SPACE,
          y.ENVIRONMENT,
          "class",
          "style"
        ],
        // Adding or removal of new nodes
        childList: !0,
        // Include children
        subtree: !0
      }), () => i.disconnect();
    });
    /** Sends resize start and end event to the editor, on end it also sends the tagged elements again */
    g(this, "addResizeListener", () => {
      const { targetOrigin: n } = this.options, i = new ResizeObserver(() => {
        this.isResizing || (this.isResizing = !0, F(ne.RESIZE_START, {}, n)), this.resizeTimeout && clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(() => {
          this.isResizing = !1, F(ne.RESIZE_END, {}, n), this.updateElements();
        }, this.delay);
      });
      return i.observe(document.body), () => i.disconnect();
    });
    /** Checks if the hovered element is an tagged entry and then sends it to the editor */
    g(this, "addHoverListener", () => {
      const n = Sr((a) => {
        let s;
        for (const c of a) {
          const u = c;
          if (u.nodeName === "BODY") break;
          const d = this.taggedElements.find((h) => h.element === u);
          if (d) {
            s = d;
            break;
          }
        }
        this.hoveredElement = s == null ? void 0 : s.element, this.updateElements();
      }, this.delay), i = (a) => {
        n(a.composedPath());
      };
      return window.addEventListener("mouseover", i, { passive: !0 }), () => window.removeEventListener("mouseover", i);
    });
    g(this, "sendTaggedElements", () => {
      F(
        ne.TAGGED_ELEMENTS,
        {
          elements: this.taggedElements.map((n) => ({
            // Important: do not add `element` as it can't be cloned by sendMessage
            coordinates: n.coordinates,
            isVisible: n.isVisible,
            attributes: n.attributes,
            isHovered: this.hoveredElement === n.element
          })),
          automaticallyTaggedCount: this.automaticallyTaggedCount,
          manuallyTaggedCount: this.manuallyTaggedCount
        },
        this.options.targetOrigin
      );
    });
    /**
     * Finds all elements that have all inspector mode attributes
     * and sends them to the editor
     */
    g(this, "updateElements", () => {
      const { taggedElements: n, manuallyTaggedCount: i, automaticallyTaggedCount: a } = Fe({
        options: this.options
      }), s = n.map(({ element: c, attributes: u }) => ({
        element: c,
        coordinates: c.getBoundingClientRect(),
        attributes: u,
        isVisible: c.checkVisibility({
          checkOpacity: !0,
          checkVisibilityCSS: !0
        })
      }));
      Dr(s, this.taggedElements) || (this.observersCB.forEach((c) => c()), this.observersCB = [], this.taggedElements = s, n.forEach(({ element: c }) => this.observe(c)), this.manuallyTaggedCount = i, this.automaticallyTaggedCount = a);
    });
    this.options = n, this.intersectionObserver = new IntersectionObserver(
      (i) => {
        const a = this.taggedElements;
        for (const s of i)
          if (s.isIntersecting)
            for (const c of a)
              c.element === s.target && (c.coordinates = s.intersectionRect, c.isVisible = s.target.checkVisibility({
                checkOpacity: !0,
                checkVisibilityCSS: !0
              }));
        this.taggedElements = a, this.sendTaggedElements();
      },
      { threshold: 0.15 }
    );
  }
}
const { parse: kr, stringify: Br } = JSON, zr = String, Fr = "string", Pr = "object", Hr = (t, n) => n, Et = (t, n, i) => {
  const a = zr(n.push(i) - 1);
  return t.set(i, a), a;
}, Vr = (t, n, i) => {
  const a = Hr, s = /* @__PURE__ */ new Map(), c = [], u = [];
  let d = +Et(s, c, a.call({ "": t }, "", t)), h = !d;
  for (; d < c.length; )
    h = !0, u[d] = Br(c[d++], f, i);
  return "[" + u.join(",") + "]";
  function f(E, b) {
    if (h)
      return h = !h, b;
    const I = a.call(this, E, b);
    switch (typeof I) {
      case Pr:
        if (I === null) return I;
      case Fr:
        return s.get(I) || Et(s, c, I);
    }
    return I;
  }
};
var P = /* @__PURE__ */ ((t) => (t.CONNECTED = "CONNECTED", t.DISCONNECTED = "DISCONNECTED", t.ERROR = "ERROR", t.TAGGED_FIELD_CLICKED = "TAGGED_FIELD_CLICKED", t.URL_CHANGED = "URL_CHANGED", t.SUBSCRIBED = "SUBSCRIBED", t.UNSUBSCRIBED = "UNSUBSCRIBED", t.ENTRY_UPDATED = "ENTRY_UPDATED", t.ENTRY_SAVED = "ENTRY_SAVED", t.DEBUG_MODE_ENABLED = "DEBUG_MODE_ENABLED", t))(P || {});
function Yr(t, n) {
  F(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      ...t
    },
    n
  );
}
function Kr(t, n) {
  F(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      ...t
    },
    n
  );
}
class Jr {
  constructor({ locale: n, targetOrigin: i }) {
    g(this, "subscriptions", /* @__PURE__ */ new Map());
    g(this, "defaultLocale");
    g(this, "sendMessage");
    this.defaultLocale = n, this.sendMessage = (a, s) => F(a, s, i);
  }
  /** Receives the data from the message event handler and calls the subscriptions */
  async receiveMessage(n) {
    if (n.method === P.ENTRY_UPDATED) {
      const { data: i, subscriptionId: a } = n, s = this.subscriptions.get(a);
      s ? (s.callback(i), s.data = i, this.subscriptions.set(a, s)) : W.error("Received an update for an unknown subscription", {
        subscriptionId: a,
        data: i,
        subscriptions: this.subscriptions
      });
    }
  }
  /**
   * Subscribe to data changes from the Editor, returns a function to unsubscribe
   * Will be called once initially for the restored data
   */
  subscribe(n) {
    const i = Ir(), a = n.locale ?? this.defaultLocale;
    this.subscriptions.set(i, {
      ...n
    });
    const s = {
      locale: a,
      event: "edit",
      id: i,
      config: Vr(n)
    };
    return this.sendMessage(P.SUBSCRIBED, s), () => {
      this.sendMessage(P.UNSUBSCRIBED, s), this.subscriptions.delete(i);
    };
  }
}
class qr {
  constructor({ locale: n, options: i }) {
    g(this, "locale");
    g(this, "options");
    g(this, "subscription");
    this.locale = n, this.options = i;
  }
  subscribe(n) {
    return this.subscription && W.log(
      "There is already a subscription for the save event, the existing one will be replaced."
    ), this.subscription = n, () => {
      this.subscription = void 0;
    };
  }
  receiveMessage(n) {
    if (n.method === P.ENTRY_SAVED && this.subscription) {
      const { entity: i } = n;
      Nt({ options: this.options }).includes(i.sys.id) && this.subscription(i);
    }
  }
}
const ei = It, yt = [
  "https://app.contentful.com",
  "https://app.eu.contentful.com",
  "http://localhost:3001"
  // for local debugging for Contentful engineers
], L = class L {
  // Static method to initialize the LivePreview SDK
  static init(n) {
    var f;
    if (typeof n != "object" || !(n != null && n.locale))
      throw new Error(
        "Init function have to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)"
      );
    const {
      debugMode: i,
      enableInspectorMode: a,
      enableLiveUpdates: s,
      locale: c,
      environment: u,
      space: d,
      targetOrigin: h
    } = n;
    if (typeof window < "u") {
      if (!Ar())
        return this.liveUpdatesEnabled = !1, Promise.resolve(null);
      if (i && ht(i), typeof a == "boolean" && (this.inspectorModeEnabled = a), typeof s == "boolean" && (this.liveUpdatesEnabled = s), this.locale = c, this.space = d, this.environment = u, this.initTargetOrigin(h), this.initialized)
        return W.log("You have already initialized the Live Preview SDK."), Promise.resolve(L.inspectorMode);
      this.inspectorModeEnabled && (this.inspectorMode = new Gr({
        locale: c,
        space: d,
        environment: u,
        targetOrigin: this.targetOrigin,
        ignoreManuallyTaggedElements: (f = n.experimental) == null ? void 0 : f.ignoreManuallyTaggedElements
      })), this.liveUpdatesEnabled && (this.liveUpdates = new Jr({ locale: c, targetOrigin: this.targetOrigin }), this.saveEvent = new qr({
        locale: c,
        options: {
          locale: this.locale,
          space: this.space,
          environment: this.environment,
          targetOrigin: this.targetOrigin
        }
      })), window.addEventListener("message", (O) => {
        var v, N, G;
        if (Or(O)) {
          if (W.log("Received message", O.data), O.data.method === P.DEBUG_MODE_ENABLED) {
            ht(!0);
            return;
          }
          this.inspectorModeEnabled && ((v = this.inspectorMode) == null || v.receiveMessage(O.data)), this.liveUpdatesEnabled && ((N = this.liveUpdates) == null || N.receiveMessage(O.data), (G = this.saveEvent) == null || G.receiveMessage(O.data));
        }
      }), Tr(() => {
        F(
          P.URL_CHANGED,
          {
            action: P.URL_CHANGED,
            taggedElementCount: document.querySelectorAll(
              `[${y.ENTRY_ID}]`
            ).length
          },
          this.targetOrigin
        );
      });
      const { taggedElements: E, manuallyTaggedCount: b, automaticallyTaggedCount: I } = this.inspectorModeEnabled ? Fe({
        options: {
          locale: this.locale,
          space: this.space,
          environment: this.environment
        }
      }) : {
        taggedElements: [],
        manuallyTaggedCount: 0,
        automaticallyTaggedCount: 0
      }, R = E.length;
      return F(
        P.CONNECTED,
        {
          action: P.CONNECTED,
          connected: !0,
          tags: R,
          taggedElementCount: R,
          locale: this.locale,
          isInspectorEnabled: this.inspectorModeEnabled,
          isLiveUpdatesEnabled: this.liveUpdatesEnabled,
          manuallyTaggedElementCount: b,
          automaticallyTaggedElementCount: I
        },
        this.targetOrigin
      ), this.initialized = !0, Promise.resolve(L.inspectorMode);
    }
  }
  static initTargetOrigin(n) {
    if (n)
      this.targetOrigin = Array.isArray(n) ? n : [n];
    else {
      const i = window.location.ancestorOrigins, a = i ? yt.find((s) => i.contains(s)) : (
        //less consistent workaround for Firefox, where ancestorOrigins is not supported
        yt.find((s) => document.referrer.includes(s))
      );
      if (!a)
        throw new Error(
          "The current origin is not supported. Please provide a targetOrigin in the live preview configuration."
        );
      this.targetOrigin = [a];
    }
  }
  static subscribe(n, i) {
    if (!this.liveUpdatesEnabled)
      return () => {
      };
    const a = typeof n == "string" ? n : "edit", s = typeof n == "object" ? n : i;
    if (a === "save") {
      if (!this.saveEvent)
        throw new Error(
          "Save event is not initialized, please call `ContentfulLivePreview.init()` first."
        );
      return this.saveEvent.subscribe(s.callback);
    }
    if (!this.liveUpdates)
      throw new Error(
        "Live updates are not initialized, please call `ContentfulLivePreview.init()` first."
      );
    return this.liveUpdates.subscribe(s);
  }
  // Static method to render live preview data-attributes to HTML element output
  static getProps(n) {
    const { fieldId: i, locale: a, environment: s, space: c } = n;
    if (!this.inspectorModeEnabled)
      return null;
    if (i) {
      const u = {
        ...a ? { [y.LOCALE]: a } : {},
        ...s ? { [y.ENVIRONMENT]: s } : {},
        ...c ? { [y.SPACE]: c } : {},
        [y.FIELD_ID]: i
      };
      if (a && (u[y.LOCALE] = a), n.assetId !== void 0)
        return {
          ...u,
          [y.ASSET_ID]: n.assetId
        };
      if (n.entryId !== void 0)
        return {
          ...u,
          [y.ENTRY_ID]: n.entryId
        };
    }
    return W.warn("Missing property for inspector mode", { ...n }), null;
  }
  static toggleInspectorMode() {
    return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
  }
  static toggleLiveUpdatesMode() {
    return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
  }
  static openEntryInEditor(n) {
    const i = {
      locale: this.locale,
      environment: this.environment,
      space: this.space
    };
    if (n.assetId !== void 0 && n.fieldId) {
      Kr(
        {
          ...i,
          ...n
        },
        this.targetOrigin
      );
      return;
    }
    if (n.entryId !== void 0 && n.fieldId) {
      Yr(
        {
          ...i,
          ...n
        },
        this.targetOrigin
      );
      return;
    }
    W.error("Please provide field id and entry id to openEntryInEditor.");
  }
  /**
   * Returns a list of tagged entries on the page
   */
  static getEntryList() {
    return Nt({
      options: {
        locale: this.locale,
        space: this.space,
        environment: this.environment
      }
    });
  }
};
g(L, "initialized", !1), g(L, "inspectorMode", null), g(L, "liveUpdates", null), g(L, "saveEvent", null), g(L, "inspectorModeEnabled", !0), g(L, "liveUpdatesEnabled", !0), g(L, "locale"), g(L, "space"), g(L, "environment"), g(L, "sendMessage"), g(L, "targetOrigin");
let mt = L;
export {
  mt as C,
  ne as I,
  _r as L,
  ei as V,
  Qr as a,
  Wr as b,
  vr as c,
  Sr as d,
  P as e,
  Kr as f,
  Dr as i,
  Yr as o,
  Xr as u
};
//# sourceMappingURL=index-DTAeTYjK.js.map
